export default {"src":"/_next/static/media/arrowRight.91fa8d19.svg","height":12,"width":19};